import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'
import VueMeta from 'vue-meta'
import VueLazyload from 'vue-lazyload'
import VueYouTubeEmbed from 'vue-youtube-embed'
import { sync } from 'vuex-router-sync'
import ga from 'vue-ga'
import VueGtag from 'vue-gtag'

import vueFlvPlayer from 'vue-flv-player'
Vue.use(vueFlvPlayer)

Vue.config.devtools = true

import App from './App.vue'
import contentState from './lib/content-state'

import router from './router'
import store from './store'

Vue.use(VueMeta)
Vue.use(VueLazyload)
Vue.use(VueProgressBar, { color: 'var(--accent)' })
Vue.use(VueYouTubeEmbed)
Vue.use(VueGtag, {
  config: { id: "G-BDY7PXC7QP" }
})

sync(store, router)
ga(router, 'UA-35555329-32')

Vue.mixin(contentState.api({
  $store: store,
  endpoint: process.env.VUE_APP_API_ENDPOINT,
  loadStart: () => store.dispatch('updateUi', { loading: true }),
  loadEnd: () => {
    store.dispatch('updateUi', { loading: false })
    window.prerenderReady = true
  }
}))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
